/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';
import { useSelector } from 'react-redux';

import { useAction } from '../../../Common/hooks';
import { getCurrentSelectedVisit } from '../../selectors';
import { setCurrentVisitsDetails } from '../../actions';
import { getVisitsDetails } from '../../services';

const useVisitsTabs = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { visitId } = useSelector(getCurrentSelectedVisit);
  const dispatchVisitsDetailsInfo = useAction(setCurrentVisitsDetails);

  const saveVisitsDetails = async () => {
    const response = await getVisitsDetails(visitId);

    dispatchVisitsDetailsInfo(response);
    setIsLoading(false);
  };

  return { saveVisitsDetails, isLoading };
};

export default useVisitsTabs;
